'use client';

import { useState, useEffect } from 'react';
import { FaRobot } from 'react-icons/fa';

const WITTY_MESSAGES = [
  'Consulting my database of 10,000 leaky faucets...',
  "If I had hands, I'd fix this myself...",
  "Sorting repairs by 'definitely needs a professional'...",
  'Cross-referencing with my extensive HVAC knowledge...',
  'Beep boop... analyzing structural integrity...',
  'Searching for the best humans to help...',
  "This would be easier if houses didn't have so many parts...",
  'Calculating optimal wrench torque...',
  "Running advanced 'is this a plumber thing?' algorithms...",
  "Determining if duct tape is an acceptable solution... it's not.",
  'Processing... unlike that clogged drain...',
  "Matching repairs to trades faster than you can say 'load-bearing wall'...",
];

interface AICategorizationLoaderProps {
  title?: string;
}

export default function AICategorizationLoader({
  title = 'Using AI to categorize your repair list',
}: AICategorizationLoaderProps) {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % WITTY_MESSAGES.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='flex min-h-[60vh] flex-col items-center justify-center gap-6 bg-gray-100'>
      <div className='relative'>
        <div className='absolute inset-0 animate-ping rounded-full bg-blue-400/30' />
        <div className='relative flex h-20 w-20 items-center justify-center rounded-full bg-linear-to-br from-blue-500 to-indigo-600'>
          <FaRobot className='h-10 w-10 text-white' />
        </div>
      </div>
      <div className='text-center'>
        <h2 className='text-xl font-semibold text-gray-800'>{title}</h2>
        <p className='mt-3 h-5 text-sm italic text-gray-500 transition-opacity duration-300'>
          "{WITTY_MESSAGES[messageIndex]}"
        </p>
      </div>
      <div className='flex items-center gap-1.5'>
        <span
          className='h-2 w-2 animate-bounce rounded-full bg-blue-500'
          style={{ animationDelay: '0ms' }}
        />
        <span
          className='h-2 w-2 animate-bounce rounded-full bg-blue-500'
          style={{ animationDelay: '150ms' }}
        />
        <span
          className='h-2 w-2 animate-bounce rounded-full bg-blue-500'
          style={{ animationDelay: '300ms' }}
        />
      </div>
    </div>
  );
}
